import React from "react";
import {IonCol, IonList, IonRadio, IonRadioGroup, IonRow} from "@ionic/react";
import "../styles/deviceTable.css";

const DeviceTable = (props) => {

    const {data, onRadioChange, disabled} = props;

    return (
        <IonList>
            <IonRadioGroup onIonChange={onRadioChange} disabled={disabled}>
                {Array.isArray(data) && data.map((item, idx) => {
                    return (
                        <IonRow key={item.thingId || idx} className="devices-row">
                            <IonCol className="table-cell radio-button">
                                <IonRadio value={JSON.stringify({ macid: item.attributes.macid, thingId: item.thingId, serialnumber: item.attributes.serialnumber })} disabled={disabled} />
                            </IonCol>
                            <IonCol className="table-cell">
                                {item.attributes.serialnumber}
                            </IonCol>
                            <IonCol className="table-cell">
                                {item.attributes.macid}
                            </IonCol>                            
                        </IonRow>
                    );
                })}
            </IonRadioGroup>
        </IonList>
    );
}

export default DeviceTable;